import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { GetReturnLossHistoryResponseData } from '@/modules/promotion/type'
import ReturnLossHistoryTable from '../ReturnLossHistoryTable'

interface ReturnLossHistoryListingProps {
	data: GetReturnLossHistoryResponseData[]
	total: number
	isLoading?: boolean
}

export default function ReturnLossHistoryListing({
	data,
	total,
	isLoading,
}: ReturnLossHistoryListingProps) {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title="ประวัติการคืนยอดเสีย"
					description="แสดงประวัติการรับรางวัลคืนยอดเสียของผู้เล่น"
				/>
			</div>
			<Separator />
			<ReturnLossHistoryTable data={data} total={total} isLoading={isLoading} />
		</div>
	)
}
